export const SET_ATOMS = 'SET_ATOMS';
export const SET_MOLEULES = 'SET_MOLEULES';
export const SET_ORGANISMS = 'SET_ORGANISMS';
export const SET_LAYOUTS = 'SET_LAYOUTS';
export const SET_PAGES = 'SET_PAGES';
